import React, { memo } from "react";
import OlMap from "../ol-map/OlMap";

const TurbineMap = ({ turbine }) => {
  return (
    <OlMap
      turbines={[turbine]}
      lightning_strikes={turbine.turbine_lightning}
    />
  );
};

export default memo(TurbineMap);